<div class="alert shadow-lg border py-2 contrast-more:border-current border-orange-100 bg-orange-50 text-orange-800 mt-6">
	<div class="w-full min-w-o leading-7">
		<span><slot /></span>
	</div>
</div>
